import { Plus } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

// Customer-visible "Qualifications" textarea on the WO form. Renders
// above line items on the View PDF / Executed PDF / Web Review.
//
// Only meaningful for equipment-based or manual WOs — proposal-
// converted WOs already carry their own qualifications from the source
// proposal, so the parent excludes this component when `form.proposal_id`
// is set. Extracted from WorkOrderTab.jsx (Feb 2026, iter177).
export function WOQualificationsSection({
  form, setForm, isEditable,
  showQualifications, setShowQualifications,
}) {
  return (
    <div className="border-t pt-4" data-testid="qualifications-section">
      {showQualifications ? (
        <div className="space-y-1">
          <Label className="text-xs">
            Qualifications{" "}
            <span className="text-slate-400 font-normal">
              (visible on PDFs &amp; web review)
            </span>
          </Label>
          <Textarea
            value={form.customer_notes || ""}
            onChange={(e) => setForm({ ...form, customer_notes: e.target.value })}
            placeholder="Optional message / scope summary for the customer..."
            className="text-sm min-h-[60px]"
            disabled={!isEditable}
            data-testid="input-wo-qualifications"
          />
        </div>
      ) : (
        isEditable && (
          <button
            type="button"
            onClick={() => setShowQualifications(true)}
            className="text-xs text-blue-600 hover:underline flex items-center gap-1"
            data-testid="btn-add-qualifications"
          >
            <Plus className="w-3 h-3" /> Add Qualifications
          </button>
        )
      )}
    </div>
  );
}
